export enum ActionTypesGraphicsController {
  FETCH_GRAPHIC = "FETCH_GRAPHIC",
  GET_PLACEMENT_SETTING = "GET_PLACEMENT_SETTING",
  GET_PLACEMENT_SETTING_SUBCOMPONENT = "GET_PLACEMENT_SETTING_SUBCOMPONENT",
  ADD_GRAPHIC_UGC_ITEM = "ADD_GRAPHIC_UGC_ITEM",
}

export enum MutationTypesGraphicsController {
  SET_GRAPHICS_SETTINGS = "SET_GRAPHICS_SETTINGS",
  SET_EDITOR_VISIBLE = "SET_EDITOR_VISIBLE",
  SET_ACTIVE_GRAPHIC_VIEWBOX = "SET_ACTIVE_GRAPHIC_VIEWBOX",
  SET_PLACEMENT_SETTING = "SET_PLACEMENT_SETTING",
  ADD_GRAPHIC_UGC_STORE_ITEM = "ADD_GRAPHIC_UGC_STORE_ITEM",
  ADD_OR_UPDATE_GRAPHIC_UGC_ITEM = "ADD_OR_UPDATE_GRAPHIC_UGC_ITEM",
  CLEAR_UGC_DATA_PER_PLACEMENT = "CLEAR_UGC_DATA_PER_PLACEMENT",
  ADD_OUT_OF_BOUNDS_MODAL_SHOWN_INFO = "ADD_OUT_OF_BOUNDS_MODAL_SHOWN_INFO",
  SET_ORIGINAL_GRAPHIC_VIEWBOX = "SET_ORIGINAL_GRAPHIC_VIEWBOX",
  SET_ORIGINAL_GRAPHIC_ZOOM_VIEWBOX = "SET_ORIGINAL_GRAPHIC_ZOOM_VIEWBOX",
  CLEAR_PLACEMENT_SETTING = "CLEAR_PLACEMENT_SETTING"
}